export type CwyNetwork = 'devnet' | 'mainnet-beta';

const env = import.meta.env;

export const CWY_NETWORK: CwyNetwork = (env.VITE_CWY_NETWORK as CwyNetwork) || 'mainnet-beta';
export const CWY_IS_MAINNET = CWY_NETWORK === 'mainnet-beta';

export const CWY_RPC_URL: string =
  env.VITE_CWY_RPC_URL ||
  (CWY_IS_MAINNET ? 'https://api.mainnet-beta.solana.com' : 'https://api.devnet.solana.com');

export const CWY_MINT_ADDRESS: string =
  env.VITE_CWY_MINT_ADDRESS ||
  (CWY_IS_MAINNET ? '' : 'Cs6FWh5FW8b6UYKf283CfTsd5rU2uN33XeCuZgmywKMf');

export const CWY_TREASURY_WALLET: string =
  env.VITE_CWY_TREASURY_WALLET ||
  (CWY_IS_MAINNET ? '' : '2PpumF9677xbSFrFi5N5Mvq7e4MKq7cxADG2FmRe86dY');

export const CWY_DECIMALS = 9;

export function cwyAmountToRaw(amountCwy: number): string {
  const raw = BigInt(Math.round(amountCwy * 10 ** CWY_DECIMALS));
  return raw.toString();
}

export function explorerTxUrl(signature: string): string {
  const cluster = CWY_IS_MAINNET ? '' : '?cluster=devnet';
  return `https://explorer.solana.com/tx/${signature}${cluster}`;
}

export function explorerAddressUrl(address: string): string {
  const cluster = CWY_IS_MAINNET ? '' : '?cluster=devnet';
  return `https://explorer.solana.com/address/${address}${cluster}`;
}

export function shortenAddress(address: string, start = 6, end = 4): string {
  if (address.length <= start + end + 1) return address;
  return `${address.slice(0, start)}…${address.slice(-end)}`;
}
